import React from 'react';

import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';

import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import Type from 'components/Shared/Type';
import Categorie from 'components/Shared/Categorie';
import Qualification from 'components/Shared/Qualification';

import TypeStep from './Steps/TypeStep';
import ClientStep from './Steps/ClientStep';
import IdentificationStep from './Steps/IdentificationStep';
import MagasinStep from './Steps/MagasinStep';
import QualificationStepFactory from './Steps/QualitificationStepFactory';

import CreateButton from './CreateButton';
import NavBarUser from '../../../Layout/NavBar/NavBarUser';

import { TypeCodes } from 'constants.js';
import { CategorieCodes } from 'constants.js';
import { QualificationCodes } from 'constants.js';

import { ReclamationQualificationDetailCodes } from 'constants.js';
import { Profils } from 'constants.js';
import { estDepotPlateforme } from 'utils/depotHelper';

const styles = theme => ({
    button: {
        marginRight: theme.spacing(1),
    },
    buttonBar: {
        float: 'right',
        paddingTop: 10
    },
    wrapper: {
        float: 'right',
        position: 'relative'
    },
    flexToolbarContainer: {
        display: 'flex',
    },
    flexItemExpand: {
        flexGrow: 1
    },
    flexItem: {
        flexGrow: 0,
        display: 'flex',
        alignItems: 'center',
        paddingRight: '58px'
    }
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class AddReclamationStepper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeStep: 0,
            activeStepKey: 0,
        };
    }

    hasClientStep = () => {

        const { reclamation } = this.props;

        return (
            reclamation.type.code === TypeCodes.Client
            || reclamation.type.code === TypeCodes.Cession
            || (reclamation.type.code === TypeCodes.Interne && reclamation.qualification && (
                reclamation.qualification.code === QualificationCodes.RetourPhysiqueSansDossier
                || reclamation.qualification.code === QualificationCodes.ClientPasRetirerMarchandise
                || reclamation.qualification.code === QualificationCodes.DossierEnAttente
                || reclamation.qualification.code === QualificationCodes.AppelTransport
            ))
        );
    }


    hasMagasinStep = () => {

        const { reclamation } = this.props;

        // Finalement, on repart de l'utilisateur
        let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

        //console.log(utilisateur);

        if (utilisateur.codePoste === Profils.Magasinier) {
            return true;
        }

        let utilisateursMagasins = utilisateur.depots ? utilisateur.depots.filter(x => !estDepotPlateforme(x.code)) : [];
        //console.log('utilisateursMagasins:', utilisateursMagasins);

        if (utilisateursMagasins.length > 1) {
            return true;
        }

        // Et on le force sur le défaut produit :

        if (reclamation.type.code === TypeCodes.Client)
        {
            if (reclamation.categorie.code === CategorieCodes.DefautProduit && utilisateur.autoriseSAV) // DefautProduitSAVAutorise mais pas simple DefautProduit
            {
                return true;
            }
        }


        return false;
    }

    hasIdentificationStep = () => {

        const { anonyme } = this.props;

        return anonyme;

    }

    stepsCondition = [
        { label: "Choix du type", condition: () => { return true; } },
        { label: "Choix du dépot", condition: this.hasMagasinStep },
        { label: "Saisie des informations client", condition: this.hasClientStep },
        { label: "Identification", condition: this.hasIdentificationStep },
        { label: "Qualification", condition: () => { return true; } }
    ];


    handleBack = () => {
        const { activeStep, activeStepKey } = this.state;

        var nextStep = activeStep - 1;
        while (!this.stepsCondition[nextStep].condition()) {
            nextStep = nextStep - 1;
        }

        this.setState({
            activeStep: nextStep,
            activeStepKey: activeStepKey - 1
        });
    };

    handleNext = () => {
        const { activeStep, activeStepKey } = this.state;

        var nextStep = activeStep + 1;
        while (!this.stepsCondition[nextStep].condition()) {
            nextStep = nextStep + 1;
        }

        this.setState({
            activeStep: nextStep,
            activeStepKey: activeStepKey + 1
        });
    };


    renderStepLabel = (index) => {
        const { activeStep } = this.state;

        const { reclamation } = this.props;

        let optional = "";

        if (activeStep !== 3) {
            var confirmationEmetteurDetail = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.ConfirmationEmetteur);

            if (confirmationEmetteurDetail && confirmationEmetteurDetail.valeurObject) {
                optional = confirmationEmetteurDetail.valeurObject.nom;
            }

        }



        switch (index) {
            case 0:
                {
                    const Optionnal = () => {
                        if (activeStep > 0) {
                            return (<span>
                                <Type typeId={reclamation.type.id} />&nbsp;/&nbsp;
                                <Categorie categorieId={reclamation.categorie.id} />&nbsp;/&nbsp;
                                <Qualification qualificationId={reclamation.qualification.id} /></span>);
                        }
                        else {
                            return (<span />);
                        }
                    };
                    return (<StepLabel optional={<Optionnal />}>{this.stepsCondition[index].label}</StepLabel>);
                }
            case 1:
                {
                    const Optionnal = () => {
                        return (<span>
                            {reclamation.magasin && reclamation.magasin.codeDepot ? `${reclamation.magasin.codeDepot} - ${reclamation.magasin.nom}` : ''}
                        </span>);
                    };
                    return (<StepLabel optional={<Optionnal />}>{this.stepsCondition[index].label}</StepLabel>);
                }
            case 2:
                {
                    const Optionnal = () => {
                        return (<span>{reclamation.client && reclamation.client.id > 0 ? reclamation.client.code + " - " + reclamation.client.libelle : ""}</span>);
                    };
                    return (<StepLabel optional={<Optionnal />}>{this.stepsCondition[index].label}</StepLabel>);
                }
            case 3:
                {
                    const Optionnal = () => (<span>{optional}</span>);
                    return (<StepLabel optional={<Optionnal />}>{this.stepsCondition[index].label}</StepLabel>);
                }
            case 4:
                {
                    const Optionnal = () => (<span>{reclamation.numeroPiece}</span>);
                    return (<StepLabel optional={<Optionnal />}>{this.stepsCondition[index].label}</StepLabel>);
                }
            default:
                break;
        }

        return (<StepLabel>{this.stepsCondition[index].label}</StepLabel>);

    }


    renderStepContent() {
        const { activeStep } = this.state;

        const { reclamation, onChange, onDetailChange, onDetailsOveride, onChangeClient, onChangeClientContact, onChangeCategorie, onChangeType,
            onSelectPiece, onAddLigne, onRemoveLigne, onLigneOuColisChange, onAddColis, onRemoveColis, onAddRetour, onRemoveRetour, validationErrors, onNextStepValid,
            namespace, reclamationLiee, onSelectAllLignes, onCheckErrors, onJokerFraisRetourChange, onClose, codeAgence, autoriseSAV, utilisateurMagasin } = this.props;

        switch (activeStep) {
            case 0: {
                return (
                    <TypeStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onChangeType={onChangeType}
                        onChangeCategorie={onChangeCategorie}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        reclamationLiee={reclamationLiee}
                    />
                );
            }
            case 1: {
                return (
                    <MagasinStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onChangeClient={onChangeClient}
                        onDetailChange={onDetailChange}
                        onNextStepValid={onNextStepValid}
                    />
                );
            }
            case 2: {
                return (
                    <ClientStep
                        reclamation={reclamation}
                        onClose={onClose}
                        onChange={onChange}
                        onChangeClient={onChangeClient}
                        onChangeClientContact={onChangeClientContact}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                    />
                );
            }
            case 3: {
                return (
                    <IdentificationStep
                        reclamation={reclamation}
                        onDetailChange={onDetailChange}
                        onNextStepValid={onNextStepValid}
                        codeAgence={codeAgence}
                    />
                );
            }
            case 4:
            default: {
                return (
                    <QualificationStepFactory
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onDetailsOveride={onDetailsOveride}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        onLigneOuColisChange={onLigneOuColisChange}
                        onAddColis={onAddColis}
                        onRemoveColis={onRemoveColis}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        onSelectAllLignes={onSelectAllLignes}
                        onCheckErrors={onCheckErrors}
                        onAddRetour={onAddRetour}
                        onRemoveRetour={onRemoveRetour}
                        onJokerFraisRetourChange={onJokerFraisRetourChange}
                        onClose={onClose}
                        autoriseSAV={autoriseSAV}
                        utilisateurMagasin={utilisateurMagasin}
                    />
                );
            }
        }

    }

    renderButtons() {

        const { activeStep } = this.state;
        const { classes, nextStepValid, validationErrors, onSubmit, onClose, reclamation, autoriseSAV } = this.props;


        return (
            <div className={classes.buttonBar}>
                {(activeStep !== this.stepsCondition.length - 1) &&
                    <div className={classes.wrapper}>


                        {(validationErrors && validationErrors.length > 0) && (
                            <Tooltip title={validationErrors[0].errorMsg}>
                                <span>
                                    <Button
                                        data-test-id="AddReclamationNextButton"
                                        disabled={!nextStepValid}
                                        variant="contained"
                                        onClick={this.handleNext}
                                        color="secondary"
                                        className={classes.button}
                                    >
                                        Suivant
                                    </Button>
                                </span>
                            </Tooltip>
                        )}


                        {(!validationErrors || validationErrors.length === 0) && (
                            <Button
                                data-test-id="AddReclamationNextButton"
                                disabled={!nextStepValid}
                                variant="contained"
                                onClick={this.handleNext}
                                color="secondary"
                                className={classes.button}
                            >
                                Suivant
                            </Button>
                        )}


                    </div>
                }

                {(activeStep === this.stepsCondition.length - 1) &&
                    <div className={classes.wrapper}>
                        <CreateButton
                            nextStepValid={nextStepValid}
                            validationErrors={validationErrors}
                            onSubmit={onSubmit}
                            onClose={onClose}
                            reclamation={reclamation}
                            autoriseSAV={autoriseSAV}
                        />
                    </div>
                }

                <div className={classes.wrapper}>
                    <Button
                        disabled={activeStep === 0}
                        onClick={this.handleBack}
                        color="secondary"
                        className={classes.button}
                    >
                        Précédent
                    </Button>
                </div>
            </div>
        );
    }



    render() {

        const { activeStep, activeStepKey } = this.state;
        const { classes, onClose } = this.props;


        let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));


        return (
            <Dialog
                fullScreen TransitionComponent={Transition}
                open
                onClose={onClose}
            >

                <div style={{ paddingTop: '64px' }}>
                    <AppBar>
                        <Toolbar className={classes.flexToolbarContainer}>
                            <Typography variant="h6" color="inherit" className={classes.flexItemExpand}>
                                Création d'un dossier après-vente
                            </Typography>


                            {utilisateur && (
                                <div className={classes.flexItem} >
                                    <NavBarUser utilisateur={utilisateur} />
                                </div>
                            )}

                        </Toolbar>
                    </AppBar>
                </div>

                <Stepper nonLinear activeStep={activeStepKey} alternativeLabel={false} orientation="horizontal" sx={{ padding: 2 }}>

                    {this.stepsCondition.map((step, index) => {
                        if (!step.condition()) {
                            return null;
                        }
                        return (
                            <Step key={`etape${index}`} completed={activeStep > index}>
                                {this.renderStepLabel(index)}
                            </Step>
                        );
                    })}

                </Stepper>

                <DialogContent sx={{ backgroundColor: 'background.default' }}>


                    {this.renderStepContent()}

                </DialogContent>


                <DialogActions sx={{ backgroundColor: 'background.default' }}>
                    {this.renderButtons()}
                </DialogActions>

            </Dialog>

        );
    }
}

AddReclamationStepper.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onCheckErrors: PropTypes.func.isRequired,
    onDetailChange: PropTypes.func.isRequired,
    onDetailsOveride: PropTypes.func.isRequired,
    onChangeClient: PropTypes.func.isRequired,
    onChangeClientContact: PropTypes.func.isRequired,
    onChangeCategorie: PropTypes.func.isRequired,
    onChangeType: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    onAddLigne: PropTypes.func.isRequired,
    onRemoveLigne: PropTypes.func.isRequired,
    onLigneOuColisChange: PropTypes.func.isRequired,
    onAddColis: PropTypes.func.isRequired,
    onRemoveColis: PropTypes.func.isRequired,
    onAddRetour: PropTypes.func.isRequired,
    onRemoveRetour: PropTypes.func.isRequired,
    validationErrors: PropTypes.array.isRequired,
    // nextStepValid: PropTypes.bool.isRequired,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired,
    reclamationLiee: PropTypes.bool.isRequired,

    anonyme: PropTypes.bool.isRequired,
    codeAgence: PropTypes.string.isRequired,
    autoriseSAV: PropTypes.bool.isRequired,
    utilisateurMagasin: PropTypes.bool.isRequired,
}

export default withStyles(styles)(AddReclamationStepper);